import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./VideoList.scss";
import {
  fetchContentPublications,
  updateStatut, 
  fetchContentPublicationsUsers
} from '../services/apiContent';
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
    Tooltip,
    Legend
  } from "chart.js";
  import { BASE_URL } from "../services/constant";
  import { useAuth } from "../context/AuthContext";
  
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend
);

const VideoList = () => {
  const [search, setSearch] = useState("");
  const [videos, setVideos] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [page, setPage] = useState(1);
  const [currentTab, setCurrentTab] = useState(1); // 1 = non publié, 2 = publié
  const [savingIds, setSavingIds] = useState({});
  const [video, setVideo] = useState(null);
  const [stats, setStats] = useState(null);
  const [daily, setDaily] = useState([]);
  const { user } = useAuth();

  const rowsPerPage = 10;

  const navigate = useNavigate();
  
  //const BASE_URL = "http://localhost:3001/api/";
  //const BASE_URL = "https://www.yaofele.com/api/";

  const userid = user?.userId;
  const categorie= user?.categorie;

  // Données fictives de test (à remplacer par ton API)
  useEffect(() => {
    async function load() {
      try {
        if(categorie === '0'){
          const data = await fetchContentPublications(2);
          setVideos(data);
          const s = await fetch(BASE_URL + "api/contents/stats/all/content").then(r => r.json());
          const d = await fetch(BASE_URL + "api/contents/stats/all/daily").then(r => r.json());
      
          setStats(s.data || { p10: 0, p10_50: 0, p50_80: 0, p100: 0 });
          setDaily(d.data);

        }else{
            const data = await fetchContentPublicationsUsers(2, userid);
            setVideos(data);
            const s = await fetch(BASE_URL + "api/contents/users/stats/all/content/"+userid).then(r => r.json());
            const d = await fetch(BASE_URL + "api/contents/users/stats/all/daily/"+userid).then(r => r.json());
        
            setStats(s.data || { p10: 0, p10_50: 0, p50_80: 0, p100: 0 });
            setDaily(d.data);

        }
      } catch (err) {
        console.error(err);
      }
    }
  
    load();
  }, [currentTab, userid, categorie]);
  

  useEffect(() => {
    setFiltered(
      videos.filter((v) =>
        v.title.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, videos]);

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  const displayed = filtered.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );
  // Limiter la description
function limitText(text, max = 250) {
  if (!text) return "";
  return text.length > max ? text.substring(0, max) + "..." : text;
}

// Convertir durée (secondes → HH:MM:SS)
function formatDuration(seconds) {
  if (!seconds || isNaN(seconds)) return "00:00";

  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = Math.floor(seconds % 60);

  // si 0 heure : n'afficher que mm:ss
  if (h === 0) {
    return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  }

  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(
    s
  ).padStart(2, "0")}`;
}
function formatNumber(num) {
  if (num < 10000) {
    return num.toString();
  }

  if (num < 1000000) {
    const value = (num / 1000).toFixed(1);
    return value.endsWith('.0') ? `${parseInt(value)}k` : `${value}k`;
  }

  const value = (num / 1000000).toFixed(1);
  return value.endsWith('.0') ? `${parseInt(value)}M` : `${value}M`;
}



// Formater date MySQL → "26 Aug 2022"
function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

const publishVideo = async (id, newStatut) => {
  try {
    setSavingIds(s => ({ ...s, [id]: true }));

    const res = await updateStatut({ id, statutpub: newStatut });

    if (!res) throw new Error("Aucune réponse du serveur");
    if (!res.ok) throw new Error("Erreur serveur");

    setVideos(prev => {
      if ((currentTab === 1 && newStatut === 2) || (currentTab === 2 && newStatut === 1)) {
        return prev.filter(v => v.id !== id);
      }
      return prev.map(v => v.id === id ? { ...v, statutpub: newStatut } : v);
    });

    alert("Opération réussie !");
  } catch (err) {
    console.error(err);
    alert("Erreur lors de la mise à jour du statut");
  } finally {
    setSavingIds(s => {
      const copy = { ...s };
      delete copy[id];
      return copy;
    });
  }
};


const chartData = {
  labels: daily.map(d => {
    const date = new Date(d.day);
    return `${date.getDate()}/${date.getMonth() + 1}`; // JJ/MM
  }),
  datasets: [
    {
      label: "Vues par jour",
      data: daily.map(d => d.views),
      borderWidth: 2,
      borderColor: "red",        // ligne rouge
      backgroundColor: "rgba(255,0,0,0.3)", // zone sous la ligne
      tension: 0.3,              // légère courbe
      with:"100%",
    },
  ],
};

const chartOptions = {
  plugins: {
    legend: {
      labels: {
        color: "#fff", // texte légende blanc
      },
    },
  },
  scales: {
    x: {
      ticks: {
        color: "#fff", // texte axe X blanc
      },
      grid: {
        color: "rgba(255,255,255,0.15)", // grille très légère
      }
    },
    y: {
      ticks: {
        color: "#fff", // texte axe Y blanc
      },
      grid: {
        color: "rgba(255,255,255,0.15)" // grille très légère
      }
    }
  }
};



  return (
    
    <div className="page-content">
    <div className="video-list-container">
    <h1 className="upload-title">Tableau de bord</h1>

      <h3>Répartition des visionnages</h3>
      <div className="stats-grid">
          <div className="stat-item"> ≤ 10% <b>{stats?.p10 ?? 0}</b> </div>
          <div className="stat-item"> 10% → 50% <b>{stats?.p10_50 ?? 0}</b> </div>
          <div className="stat-item"> 50% → 80% <b>{stats?.p50_80 ?? 0}</b> </div>
          <div className="stat-item"> 100% <b>{stats?.p100 ?? 0}</b> </div>
      </div>

      <h3>Évolution des vues (30 derniers jours)</h3>
      <div className="chart">
          <Line data={chartData} options={chartOptions} />
      </div>


      {/* Search / Filter */}
      <br />
      <h3>Le Top 20 des meilleurs videos</h3>
      <div className="filter-bar">
        <input
          type="text"
          placeholder="Filter videos..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      {/* Table */}
      <table className="video-table">
        <thead>
          <tr>
            <th></th>
            <th>Video</th>
            <th>Visibility</th>
            <th>Category</th>
            <th>Date</th>
            <th>Views</th>
            <th>Likes</th>
            <th>Dislikes</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {displayed.map((video) => (
            <tr key={video.id}>
              <td>
                <input type="checkbox" />
              </td>
              <td className="video-cell">
                <div className="thumb">
                  <img src={`${BASE_URL}api/${video.image}`} alt={video.id} />
                  <span className="duration">{formatDuration(video.duration)}</span>
                </div>
                <div className="video-info">
                  <strong>{video.title}</strong>
                  <p>{limitText(video.description, 50)}</p>
                </div>
              </td>
              <td>Public</td>
              <td>Publicité</td>
              <td>{formatDate(video.created_at)}</td>
              <td>{formatNumber(video.views)}</td>
              <td>{formatNumber(video.likes)}</td>
              <td>{formatNumber(video.dislikes)}</td>
              <td>
                <button
                  className="pub-btn published"
                  onClick={() => navigate(`/statistique/detail/${video.id}`)}
                >
                  Contenus
                </button>
              </td>

            </tr>
          ))}
        </tbody>
      </table>

      {/* Pagination */}
      <div className="pagination">
        <span>
          Rows per page: <b>{rowsPerPage}</b>
        </span>
        <span>
          {page} – {Math.ceil(filtered.length / rowsPerPage)} of{" "}
          {filtered.length}
        </span>
        <button
          disabled={page === 1}
          onClick={() => handleChangePage(page - 1)}
        >
          ‹
        </button>
        <button
          disabled={page * rowsPerPage >= filtered.length}
          onClick={() => handleChangePage(page + 1)}
        >
          ›
        </button>
      </div>
    </div>

    </div>
  );
};

export default VideoList;
